import gql from 'graphql-tag';

export const EXPORT_USER_GOALS = gql`
  query exportUserGoals($dateFrom: DateTime!, $dateTo: DateTime!) {
    report {
      exportUserGoals(start: $dateFrom, end: $dateTo) {
        contentType
        s3Key
      }
    }
  }
`;
